import { useState } from "react";
import { Row, Col, InputGroup, Form, Button, Badge, Dropdown } from "react-bootstrap";
import { SUGGESTIONS, SORT_OPTIONS } from "../data/Mockdata2";

// SearchBar
export default function SearchBar({ activeFilters = 2, resultCount = "3,145,684", query = "ui/ux design" }) {
    const [searchVal, setSearchVal] = useState("UI/UX Design");
    const [sortBy, setSortBy] = useState("Trending");
    const [activeSug, setActiveSug] = useState(null);

    return (
        <div className="top-filter-section border-bottom small pb-3 mb-4">
            {/* Row 1: Filter | Search | Sort */}
            <div className="d-flex flex-column flex-md-row flex-wrap justify-content-between row-gap-2 column-gap-3 mb-3">
                {/* Filter Button */}
                <div className="d-flex flex-column flex-sm-row flex-fill gap-2 gap-md-3">
                    <Button variant="text" className="border-primary d-flex align-items-center justify-content-center gap-2 fw-medium rounded text-primary px-2 px-sm-3">
                        <i className="bi bi-sliders2 fs-6" /> Filter
                        {activeFilters > 0 && (
                            <Badge bg="primary" text="dark" pill className="ms-1">
                                {activeFilters}
                            </Badge>
                        )}
                    </Button>

                    {/* Search Input */}
                    <InputGroup>
                        <InputGroup.Text className="bg-secondary bg-opacity-10 border-end-0">
                            <i className="bi bi-search text-muted" />
                        </InputGroup.Text>
                        <Form.Control
                            value={searchVal}
                            onChange={(e) => setSearchVal(e.target.value)}
                            placeholder="Search courses..."
                            className="border-start-0 shadow-none"
                        />
                    </InputGroup>
                </div>

                {/* Sort Dropdown */}
                <div className="d-flex align-items-center gap-2">
                    <span className="text-secondary text-nowrap">Sort by:</span>
                    <Dropdown>
                        <Dropdown.Toggle
                            variant="white"
                            className="border d-flex align-items-center gap-2"
                            style={{ minWidth: "140px" }}
                        >
                            {sortBy}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {SORT_OPTIONS.map((opt) => (
                                <Dropdown.Item
                                    key={opt}
                                    active={opt === sortBy}
                                    onClick={() => setSortBy(opt)}
                                >
                                    {opt}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>

            {/* Row 2: Suggestions | Results Count */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <div className="d-flex flex-wrap align-items-center row-gap-1 column-gap-2">
                    <span className="text-black">Suggestion:</span>
                    <span className="d-flex flex-wrap align-items-center column-gap-2">
                        {SUGGESTIONS.map((s) => (
                            <span
                                key={s}
                                role="button"
                                className={`pointer ${activeSug === s ? "text-primary" : "text-primary"}`}
                                style={{ textDecoration: activeSug === s ? "underline" : "none" }}
                                onClick={() => { setActiveSug(s); setSearchVal(s); }}
                            >
                                {s}
                            </span>
                        ))}
                    </span>
                </div>
                <div className="text-black">
                    {resultCount}
                    <span className="text-secondary ms-1">results find for &ldquo;{query}&rdquo;</span>
                </div>
            </div>
        </div>
    );
}